import { getPostbackMessage } from './getPostbackMessage'

export const getMessagesFromHistory = history => {
  return history
    .filter(event => event.message || event.customMessage)
    .map(event => {
      let message = Object.assign({}, {...event.message, ...event.customMessage})
      message.isFromBot = !!event.isFromBot
      if (message.type === 'postback') {
        message = getPostbackMessage(message)
      }
      return message
    })
    .reverse()
}
